import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Label, InputText } from '@teo/components';
import { emailRegex } from '@/constants/regex.constants';
import { axios } from '@/axios';
import { config } from '@/config';
// import { ContacsList } from './ContacsList';
import { useGet } from '@/query/fetchHooks';
import { City, Person } from '@teo/components/icons';
import { ContacsList } from '../SettingsNodes/ModalLP/ContacsList';

const ModalAddInfo = ({
  onClose,
  authOrg,
  trainingDetail,
  typeModal,
  setInstitution,
  institution,
  setInstitutionEmail,
  institutionEmail,
  setInstitutionPhone,
  institutionPhone,
  setRegistrationLink,
  registrationLink,
  setPersons,
  persons,
  setActivePerson,
  activePerson,
  trainingInstitution,
  setTrainingInstitution,
  trainingPersonIds,
  setTrainingPersonIds,
  setChangeTraining,
}) => {
  const { t } = useTranslation();
  const [mainInstitution, setMainInstitution] = useState(
    trainingInstitution || null
  );
  const [mainPerson, setMainPerson] = useState(activePerson || null);
  const [name, setName] = useState(
    typeModal === 'institution'
      ? institution || ''
      : typeModal === 'person'
      ? activePerson?.contactName || ''
      : ''
  );
  const [email, setEmail] = useState(
    typeModal === 'institution'
      ? institutionEmail || ''
      : typeModal === 'person'
      ? activePerson?.contactEmail || ''
      : ''
  );
  const [phone, setPhone] = useState(
    typeModal === 'institution'
      ? institutionPhone || ''
      : typeModal === 'person'
      ? activePerson?.contactPhone || ''
      : ''
  );
  const [link, setLink] = useState(registrationLink || '');
  const [validEmail, setValidEmail] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validLink, setValidLink] = useState(false);
  const [emailWasTouched, setEmailWasTouched] = useState(false);

  const [disabledEdit, setDisabledEdit] = useState(false);

  let title;
  let nameLabel;
  switch (typeModal) {
    case 'institution':
      title =
        trainingDetail?.trainingType === 'evaluation'
          ? t('pages.learning_path.modal_add.edit_ev_institution')
          : t('pages.learning_path.modal_add.edit_tr_institution');
      nameLabel =
        trainingDetail?.trainingType === 'evaluation'
          ? t('pages.learning_path.modal_add.ev_institution_name')
          : t('pages.learning_path.modal_add.tr_institution_name');
      break;
    case 'newInstitution':
      title =
        trainingDetail?.trainingType === 'evaluation'
          ? t('pages.learning_path.modal_add.add_tr_institution')
          : t('pages.learning_path.modal_add.add_tr_institution');
      nameLabel =
        trainingDetail?.trainingType === 'evaluation'
          ? t('pages.learning_path.modal_add.tr_institution_name')
          : t('pages.learning_path.modal_add.add_tr_institution');
      break;
    case 'person':
      title = t('pages.learning_path.modal_add.edit_contact_person');
      nameLabel = t('pages.learning_path.modal_add.contact_person_name');
      break;
    case 'newPerson':
      title = t('pages.learning_path.modal_add.add_contact_person');
      nameLabel = t('pages.learning_path.modal_add.contact_person_name');
      break;
    case 'link':
      title = t('pages.learning_path.modal_add.add_registration_link');
      nameLabel = t('pages.learning_path.modal_add.registration_link');
      break;
    case 'trainingLink':
      title = t('pages.learning_path.modal_add.add_training_link');
      nameLabel = t('pages.learning_path.modal_add.link_training');
      break;
    default:
      title = t('');
      nameLabel = t('');
      break;
  }

  const saveInstitution = async () => {
    const changes = {};
    if (name !== institution) {
      setInstitution(name);
      changes.institutionName = name;
    }
    if (email !== institutionEmail) {
      setInstitutionEmail(email);
      changes.institutionEmail = email;
    }
    if (phone !== institutionPhone) {
      setInstitutionPhone(phone);
      changes.institutionPhone = phone;
    }
    onClose();
  };

  const saveLink = async () => {
    if (link !== registrationLink) {
      setRegistrationLink(link);
      setChangeTraining((prev) => ({ ...prev, url: link }));
    }
    onClose();
  };

  const savePerson = async (newCPerson) => {
    if (typeModal === 'person') {
      const editPerson = persons?.map((prs) => {
        if (prs?.id === activePerson?.id) {
          return {
            ...prs,
            contactName: name,
            contactEmail: email,
            contactPhone: phone,
          };
        } else {
          return prs;
        }
      });

      setTrainingPersonIds(editPerson?.map((prs) => prs?.id));
      setPersons(editPerson);
      setActivePerson(null);
      onClose();
    }
    if (typeModal === 'newPerson') {
      const newPerson = persons?.concat(newCPerson);
      setTrainingPersonIds(newPerson?.map((prs) => prs?.id));
      setPersons(newPerson);
      onClose();
    }
  };

  // useEffect(() => {
  //   if (name) {
  //     setValidName(false);
  //   } else {
  //     setValidName(true);
  //   }
  // }, [name]);

  useEffect(() => {
    setValidEmail(emailRegex.test(email));
  }, [email]);

  const save = async () => {
    if (typeModal === 'institution' || typeModal === 'newInstitution') {
      if (name && email && validEmail) {
        if (mainInstitution?.id) {
          if (mainInstitution?.id === trainingDetail?.institutionId) {
            await axios.put(
              `${config.backend}/contact/${trainingDetail?.institutionId}`,
              {
                contactName: name,
                contactEmail: email,
                contactPhone: phone,
              }
            );
            setTrainingInstitution(mainInstitution);
            saveInstitution();
          } else {
            await axios.put(
              `${config.backend}/contact/${mainInstitution?.id}`,
              {
                contactName: name,
                contactEmail: email,
                contactPhone: phone,
              }
            );
            setChangeTraining((prev) => ({
              ...prev,
              institutionId: mainInstitution?.id,
            }));
            setTrainingInstitution(mainInstitution);
            saveInstitution();
          }
        } else {
          const newInstitution = await axios.post(
            `${config.backend}/contacts`,
            {
              contactName: name,
              organisationId: authOrg,
              contactEmail: email,
              contactPhone: phone,
              contactType: 'organisation',
            }
          );
          setChangeTraining((prev) => ({
            ...prev,
            institutionId: newInstitution?.data?.id,
          }));
          setTrainingInstitution(mainInstitution);
          saveInstitution();
        }
      } else {
        if (!name) {
          setValidName(true);
        }
        if (email === '' || !validEmail) {
          setEmailWasTouched(true);
        }
      }
    }
    if (typeModal === 'person' || typeModal === 'newPerson') {
      if (name && email && validEmail) {
        if (mainPerson?.id) {
          if (mainPerson?.id === activePerson?.id) {
            await axios.put(`${config.backend}/contact/${mainPerson?.id}`, {
              contactName: name,
              contactEmail: email,
              contactPhone: phone,
            });
            savePerson();
          } else {
            if (typeModal === 'newPerson') {
              await axios.put(`${config.backend}/contact/${mainPerson?.id}`, {
                contactName: name,
                contactEmail: email,
                contactPhone: phone,
              });
              setChangeTraining((prev) => ({
                ...prev,
                contactPersonIds: [...trainingPersonIds, mainPerson?.id],
              }));
              savePerson(mainPerson);
            } else {
              await axios.put(`${config.backend}/contact/${mainPerson?.id}`, {
                contactName: name,
                contactEmail: email,
                contactPhone: phone,
              });
              const newList = trainingPersonIds?.map((prs) =>
                prs === activePerson?.id ? mainPerson?.id : prs
              );
              setChangeTraining((prev) => ({
                ...prev,
                contactPersonIds: newList,
              }));
              savePerson();
            }
          }
        } else {
          const newPerson = await axios.post(`${config.backend}/contacts`, {
            contactName: name,
            organisationId: authOrg,
            contactEmail: email,
            contactPhone: phone,
            contactType: 'person',
          });

          if (activePerson?.id) {
            const newList = trainingPersonIds?.map((prs) =>
              prs === activePerson?.id ? newPerson?.data?.id : prs
            );
            setChangeTraining((prev) => ({
              ...prev,
              contactPersonIds: newList,
            }));
            savePerson(newPerson?.data);
          } else {
            setChangeTraining((prev) => ({
              ...prev,
              contactPersonIds: [...trainingPersonIds, newPerson?.data?.id],
            }));
            savePerson(newPerson?.data);
          }
        }
      } else {
        if (!name) {
          setValidName(true);
        }
        if (email === '' || !validEmail) {
          setEmailWasTouched(true);
        }
      }
    }
    if (typeModal === 'link' || typeModal === 'trainingLink') {
      if (link) {
        saveLink();
      } else {
        setValidLink(true);
      }
    }
  };

  useEffect(() => {
    if (mainPerson) {
      const foundId = trainingPersonIds.some((item) => item === mainPerson?.id);
      if (foundId && mainPerson?.id !== activePerson?.id) {
        setDisabledEdit(true);
      } else {
        setDisabledEdit(false);
      }
    } else {
      setDisabledEdit(false);
    }
  }, [mainPerson]);

  return (
    <>
      <Modal isOpen>
        <Modal.Header onClose={onClose}>{title}</Modal.Header>
        <Modal.Body>
          <div className="flex flex-col gap-6">
            {(typeModal === 'institution' ||
              typeModal === 'newInstitution') && (
              <div>
                <p className="mb-6 text-sm text-[#7D7D81]">
                  {trainingDetail?.trainingType === 'evaluation'
                    ? t('pages.learning_path.settings.select_evaluation')
                    : t('pages.learning_path.settings.select_training')}
                </p>
                <Label>
                  {trainingDetail?.trainingType === 'evaluation'
                    ? t('pages.learning_path.settings.evaluation_institution')
                    : t('pages.learning_path.settings.training_institution')}
                </Label>
                <ContacsList
                  Icon={City}
                  value={{
                    ...mainInstitution,
                    label: mainInstitution?.contactName,
                  }}
                  onChange={(value) => {
                    setMainInstitution(value);
                    setName(value?.contactName || '');
                    setEmail(value?.contactEmail || '');
                    setPhone(value?.contactPhone || '');
                  }}
                  fetch={useGet.bind(
                    null,
                    `/contacts?organisationId=${authOrg},OR,organisationId=null&contactType=organisation`
                  )}
                  defaultSort={[{ id: 'contactName', desc: false }]}
                  render={(row) => {
                    return row?.contactName;
                  }}
                />
                <div className="mt-6 -ml-6 h-[1px] w-[calc(100%_+_48px)] bg-grey-02"></div>
              </div>
            )}
            {(typeModal === 'person' || typeModal === 'newPerson') && (
              <div>
                <p className="mb-6 text-sm text-[#7D7D81]">
                  {t('pages.learning_path.settings.select_person')}
                </p>
                <Label>
                  {t('pages.learning_path.settings.contact_person')}
                </Label>
                <ContacsList
                  Icon={Person}
                  value={{
                    ...mainPerson,
                    label: mainPerson?.contactName,
                  }}
                  onChange={(value) => {
                    setMainPerson(value);
                    setName(value?.contactName || '');
                    setEmail(value?.contactEmail || '');
                    setPhone(value?.contactPhone || '');
                  }}
                  fetch={useGet.bind(
                    null,
                    `/contacts?organisationId=${authOrg},OR,organisationId=null&contactType=person`
                  )}
                  defaultSort={[{ id: 'contactName', desc: false }]}
                  render={(row) => {
                    return row?.contactName;
                  }}
                />
                <div className="mt-6 -ml-6 h-[1px] w-[calc(100%_+_48px)] bg-grey-02"></div>
              </div>
            )}
            {(typeModal === 'link' || typeModal === 'trainingLink') && (
              <div>
                <Label htmlFor="link-registration">{nameLabel}</Label>
                <InputText
                  id="link-registration"
                  onChange={(event) => {
                    setLink(event.target.value);
                  }}
                  value={link}
                  placeholder={`www.leercentrum.be/opleidingen/...`}
                  required
                  onBlur={() => {
                    if (link) {
                      setValidLink(false);
                    } else {
                      setValidLink(true);
                    }
                  }}
                  hasError={validLink}
                />
              </div>
            )}
            {(typeModal === 'institution' ||
              typeModal === 'newInstitution' ||
              typeModal === 'person' ||
              typeModal === 'newPerson') && (
              <>
                <div>
                  <Label htmlFor="name">{nameLabel}</Label>
                  <InputText
                    id="name"
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                    value={name}
                    onBlur={() => {
                      if (name) {
                        setValidName(false);
                      } else {
                        setValidName(true);
                      }
                    }}
                    required
                    hasError={validName}
                  />
                </div>
                <div>
                  <Label htmlFor="email">
                    {t('pages.learning_path.modal_add.email_address')}
                  </Label>
                  <InputText
                    id="email"
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                    onBlur={(e) => {
                      if (!validEmail || e.target.value === '') {
                        setEmailWasTouched(true);
                      } else {
                        setEmailWasTouched(false);
                      }
                    }}
                    value={email}
                    placeholder={t(
                      'pages.learning_path.modal_add.placeholder_email'
                    )}
                    required
                    hasError={emailWasTouched}
                  />
                </div>
                <div>
                  <Label htmlFor="phone">
                    {t('pages.learning_path.modal_add.telephone_number')}
                  </Label>
                  <InputText
                    id="phone"
                    type="number"
                    onChange={(event) => {
                      setPhone(event.target.value);
                    }}
                    value={phone}
                    placeholder={t(
                      'pages.learning_path.modal_add.placeholder_phone'
                    )}
                    required
                    className="max-w-[190px]"
                  />
                </div>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex w-full justify-between">
            <Button variant="ghost" onClick={onClose}>
              {t('button.cancel')}
            </Button>

            <Button onClick={() => save()} disabled={disabledEdit}>
              {title}
            </Button>
            {/* <Button
              onClick={() => axios.delete(`${config.backend}/contact/18`)}
            >
              {title}
            </Button> */}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalAddInfo;
